import { ErrorMessage, Field, Formik, useFormik, Form } from "formik";
import { useEffect, useState, useRef } from "react";
import { Card,Button,Collapse,  Col, Row } from "react-bootstrap";
import Breadcrumbs from "../../../shared/components/Breadcrumbs"
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import DefaultButton from "../../../shared/components/DefaultButton";
import ListView from "../../../shared/components/listview/ListView"
import { loadTeamPlanGetDataRequest, loadPlanByLocLevelGetDataRequest, loadPlanByEmpLocPerGetDataRequest } from "../redux/Actions"
import Modalpopup from "../../../shared/components/Modalpopup"
import FormError from "../../../shared/components/FormError"
import MyPlanView from "./MyPlanView"
import GeneratePDF from "./GeneratePDF";

import { loadMarketDataRequest } from "../../market/redux/Actions";
import { loadRegionDataRequest } from "../../region/redux/Actions";

import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import Loader from '../../../shared/components/Loader';

//import { CANCEL, DIVISION, EMPLOYEE_DEPARTMENT, EMPLOYEE_STATUS, HIRE_STATUS, HOURLY_SALARY, JOB_TITLE, MARKET, PART_FULL_TIME, REGION, SAVE, STORE } from "../../../shared/constants/Constants";

const AllPlan = () => {
    const dispatch = useDispatch();
    const formik = useFormik({});  
    const location = useLocation();
    let navigate = useNavigate();

    const getQuarter = (date) => {
        const month = date.getMonth() + 1; 
        if (month >= 1 && month <= 3) {
          return 'Q1';
        } else if (month >= 4 && month <= 6) {
          return 'Q2';
        } else if (month >= 7 && month <= 9) {
          return 'Q3';
        } else {
          return 'Q4';
        }
      };
   
    let currentYear = new Date().getFullYear();
    let currentQuarter = getQuarter(new Date());

    let { teamplans } = useSelector((state) => state.myPlans);
    let [errorMessage, setErrorMessage] = useState(false);
    

    let [showEditModal, setShowEditModal] = useState(false)
    let [shouldCloseModal, setShouldCloseModal] = useState(false);
    let [selectedPlan, setSelectedPlan] = useState({});
    let [clickViewFunc, setClickViewFunc] = useState(null);
    let [clickDrillDownFunc, setClickDrillDownFunc] = useState(null);
    let [selectedYear, setSelectedYear] =  useState(currentYear);
    let [selectedQuarter, setSelectedQuarter] =  useState(currentQuarter);
    let [selectedRegion, setSelectedRegion] =  useState();
    let [selectedMarket, setSelectedMarket] =  useState();
    let [filteredMarket, setFilteredMarket] =  useState([]);
    let [childBreadCrumbs, setChildBreadCrumbs] = useState([
        { href: '/allplan', label: "All Priority Plans"  }
    ])
    //let [currentLocationLevel, setCurrentLocationLevel] = useState('region');
    const currentLocationLevel = useRef('region');
    const selectedYearRef = useRef(currentYear);
    const selectedQuarterRef = useRef(currentQuarter);
    
    let [clickDownloadFunc, setClickDownloadFunc] = useState(null);   
    let [downloadBlock, setDownloadBlock] =  useState(false);    
    let [selectedDownloadPlan, setSelectedDownloadPlan] = useState({});
    const selectedDownloadPlanRef = useRef(null);
    const [isDownload, setIsDownload] = useState(false);

    const { regions } = useSelector(store => store.region);
    const { markets } = useSelector(store => store.market);
    
    useEffect(() => {
       
        if (markets.length === 0) {
            dispatch(loadMarketDataRequest())
        }
        if (regions.length === 0) {
            dispatch(loadRegionDataRequest());
        }
    }, [dispatch])

    const columnDefs = [
        {
            display_name: "id",
            field: "id",
            type: "number",
            hide: true,
            pinned:'left',
        },
        {
            display_name: currentLocationLevel.current.charAt(0).toUpperCase() + currentLocationLevel.current.slice(1) ,
            field: "location_name",
            type: "hyperlink",
            redirect_value: "function",
            functionTo: clickDrillDownFunc,
        } ,
        {
            display_name: "Start Date",
            field: "start_date",
            type: "text"
        },
        {
            display_name: "End Date",
            field: "end_date",
            type: "text"
        },
        {
            display_name: "Manager",
            field: "full_name",
            type: "text"
        },
        {
            display_name: "Job Title",
            field: "job_title",
            type: "text"
        },  
        {
            display_name: "Current Manager",
            field: "current_manager",
            type: "text"
        },       
        {
            display_name: "Progress",
            field: 'progress',
            type: "progressbar",
            width: 100
        },
        {
            display_name: 'Actions',
            field: 'actions',
            hide: false
        },
    ]

    
    const closeEditModal = () => {
        setShowEditModal(false);
        setErrorMessage(null);
    }

    const handleEdit = (values) => {
        //dispatch(loadEmployeeTypeTrackerEditDataRequest(values))
        setShouldCloseModal(true);
    }

    useEffect(() => {        
        setClickViewFunc(
            () => (row) => {
                setSelectedPlan(row);
                setDownloadBlock(false);
                setShowEditModal(true);
            })   
    }, [])

    useEffect(() => {
        setClickDownloadFunc(
            () => async (row) => { 
                setDownloadBlock(true);
                setSelectedDownloadPlan(row);
                selectedDownloadPlanRef.current = row;
                let request = {
                    "employee_id": row['employee_id'],
                    "location_id": row['loc_id'],
                    "period": selectedQuarterRef.current,
                    "year": selectedYearRef.current
                }
              dispatch(loadPlanByEmpLocPerGetDataRequest(request));
              setDownloadBlock(true);                
            });
                
    }, [dispatch, selectedQuarter, selectedYear]); 

   /* useEffect(() => {        
        setClickDownloadFunc(() => (row) => {
                setDownloadBlock(true);
                setSelectedDownloadPlan(row);
                selectedDownloadPlanRef.current = row; 
                console.log('Testing',selectedDownloadPlanRef.current);  
               setTimeout(() => {
                   const input = document.getElementById("download-content");
                    setDownloadBlock(true);
                    html2canvas(input, { scale: 2 }).then((canvas) => {                        
                        const imgData = canvas.toDataURL("image/jpeg", 0.8); // compress image
                        const pdf = new jsPDF('p', 'pt', 'a4');
                        const pdfWidth = pdf.internal.pageSize.getWidth();
                        const pdfHeight = pdf.internal.pageSize.getHeight();
                        const imgProps = pdf.getImageProperties(imgData);
                        const imgHeight = (imgProps.height * pdfWidth) / imgProps.width;
                        let heightLeft = imgHeight;
                        let position = 0;
                        pdf.addImage(imgData, 'JPEG', 0, position, pdfWidth, imgHeight);
                        heightLeft -= pdfHeight;
                        while (heightLeft >= 0) {
                            position = heightLeft - imgHeight;
                            pdf.addPage();
                            pdf.addImage(imgData, 'JPEG', 0, position, pdfWidth, imgHeight);
                            heightLeft -= pdfHeight;
                        }
                        let fileName = selectedDownloadPlanRef.current["full_name"] + "_" + selectedDownloadPlanRef.current["period_name"] + ".pdf";
                        pdf.save(fileName);
                        setDownloadBlock(false);

                    });
                }, 1000); 
            })   
    }, []) */

    useEffect(() => {
        setClickDrillDownFunc(
            () => (row) => {
                setDownloadBlock(false);
                //console.log("currentLocationLevel",currentLocationLevel)
                //console.log("Drilling down with year:", selectedYearRef.current, "quarter:", selectedQuarterRef.current)
                if(currentLocationLevel.current != 'market') {
                    setSelectedPlan(row);
                    const newRandomString = Date.now()
                    setChildBreadCrumbs ([
                        { href: '/allplan?level='+newRandomString, label: "All Priority Plans"  },
                        { href: '/allplan', label: row.location_name }
                    ])
                    currentLocationLevel.current = 'market';
                    let request = {
                        year: selectedYearRef.current,
                        quarter: selectedQuarterRef.current,
                        location_level:'market',
                        location_id: row.loc_id
                    }
                    dispatch(loadPlanByLocLevelGetDataRequest(request));
            }

        })
    }, [dispatch])
    
    // useEffect(() => {
    //     console.log("loading team priority with location change")
    //     setChildBreadCrumbs ([
    //         { href: '/allplan?filter={"level":"region"}', label: "All Priority Plans"  }
    //     ])
    //     let request = {
    //         year:selectedYear,
    //         quarter:selectedQuarter,
    //         location_level:'region',
    //         location_id: 100
    //     }
    //     dispatch(loadPlanByLocLevelGetDataRequest(request));     
    //      // setInitialValues(myplan)  
    // }, [location.search,location.pathname]);
    
    console.log("setCurrentLocationLevel", currentLocationLevel);
    useEffect(() => {
        console.log("loading team priority intial load")
        setChildBreadCrumbs ([
            { href: '/allplan?filter={"level":"region"}', label: "All Priority Plans"  }
        ])
        currentLocationLevel.current = 'region'; 
        let request = {
            year:selectedYear,
            quarter:selectedQuarter,
            location_level:'region',
            location_id: 100
        }
        dispatch(loadPlanByLocLevelGetDataRequest(request));     
         // setInitialValues(myplan)  
    }, [dispatch, location.pathname, location.search]);
    
    let staticYears = [];
	for (var i = 2024; i <= currentYear; i++) {
		let obj = {};
		obj["name"] = i;
		obj["value"] = i;
		staticYears.push(obj)
	}

    const changeSelectedYear = (value) => {
		setSelectedYear(value);
        selectedYearRef.current = value;
	}
    const changeRegion = (value) => {
		setSelectedRegion(value);
        setSelectedMarket('');
        reloadMarket(value)
	}

    const changeMarket = (value) => {
		setSelectedMarket(value);        
	}
    const reloadMarket = (value) => {
        console.log("selectedRegion" , value)
        console.log("selectedRegion" , selectedRegion)
        const newFilteredMarket = markets.filter(market => market.region_id === value);
        setFilteredMarket(newFilteredMarket);
        console.log("newFilteredMarket", newFilteredMarket)
        console.log("setFilteredMarket", filteredMarket)
    }   
    const changeSelectedQuarter = (value) => {
		setSelectedQuarter(value);
        selectedQuarterRef.current = value;
	}
    const searchByYrandQuarter = () => {
		console.log(selectedYear, selectedQuarter )
        // let filtertype =  (selectedMarket == undefined || selectedMarket == '' || selectedMarket == null ) ? 'region' : 'market';
        // let request = {
        //     year:selectedYear,
        //     quarter:selectedQuarter,
        //     region_id: selectedRegion,
        //     market_id: selectedMarket,
        //     type: filtertype, 
        //     from: 'all'
        // }
        // dispatch(loadTeamPlanGetDataRequest( request));     
        currentLocationLevel.current = 'region'
        let request = {
            year:selectedYear,
            quarter:selectedQuarter,
            location_level:'region',
            location_id: 100
        }
        dispatch(loadPlanByLocLevelGetDataRequest(request));  
	}

    // const goBack = () => {
    //     setChildBreadCrumbs ([
    //         { href: '/allplan?filter={"level":"region"}', label: "All Priority Plans"  }
    //     ])
    //     navigate('/allplan?filter={"level":"region"}')
	// }
   
 
  const rowClassRules = {
    'completed-row': (params) => params.data.end_date != '2099-12-31',
  };
        
    console.log("setSelectedYear", selectedYear)
    return <>
        {/* <Breadcrumbs children={[{ label: "All Priority Plans" }]} />        */}
        <Breadcrumbs children={childBreadCrumbs} />
        <div className="d-flex justify-content-end"  style={{ width:'100%' }}>
            <div className="mb-1"> 
                <select  className=" mx-1  year-select " style={{ height:'33px', width: '100px', display:'none' }} onChange={(e) => {
                    changeRegion(e.target.value) }}>
                    <option value={''}> { 'select region'} </option>
                    {regions.filter(region => ((region.active === 0 || region.active === 2) && region.region_name != 'WVHQ' && region.region_name != 'Metro East')).map((region) =>
                        <option value={region.id}>{region.region_name}</option>
                    )}
                </select>
                <select  className=" mx-1  year-select hidden" style={{ height:'33px', width: '100px', display:'none'  }} onChange={(e) => {
                    changeMarket(e.target.value) }}>
                    <option value={''}> { 'select market'} </option>
                    {filteredMarket.filter(market => (market.active === 0 || market.active === 2)).map(market =>
                        <option value={market.id}>
                            {market.market_name}
                        </option>
                    )}
                </select>
                <select  className=" mx-1  year-select" style={{ height:'33px', width: '100px' }} onChange={(e) => {
                    changeSelectedYear(e.target.value) }}>
                    {staticYears.map((year) =>
                        year.value == currentYear ? <option key={year.value} value={year.value} selected >{year.name}</option> :
                            <option key={year.value} value={year.value} >{year.name}</option>
                    )}
                </select>

                <select className=" mx-1  year-select" style={{ height:'33px', width: '100px' }}  onChange={(e) => {
                    changeSelectedQuarter(e.target.value) }}>
                    {['Q1','Q2','Q3','Q4'].map((quarter) =>
                        quarter == currentQuarter ? <option key={quarter} value={quarter} selected >{quarter}</option> :
                            <option key={quarter} value={quarter} >{quarter}</option>
                    )}
                </select>
                <DefaultButton
                    buttonClass={"btn btn-secondary default-btn-color"}
                    buttonTitle={"Search"}
                    buttonType={"submit"}
                    actionBlock={() => {
                        searchByYrandQuarter();
                    }}                                               
                
                />
            </div>   
        </div>
        <br/>

        {/* <select value={selectedCompanyId} style={{ width: 250 }} className="float-end form-control" 
                onChange={(e) => { setSelectedCompanyId(Number.parseInt(e.target.value)) }}>
            <option value={0}>{ALL_COMPANIES}</option>
            {companies.map((company) =>
                <option key={company.id} value={company.id} >{company.company_name}</option>
            )
            }
        </select>       */}
        {isDownload && <Loader />}
        <ListView            
            columnNames={columnDefs}
            rowData={teamplans}  
            clickView={clickViewFunc}    
            clickDownload={clickDownloadFunc}  
            pact = {true}         
        />

        <Modalpopup show={showEditModal} actionTitle="View Plan" handleClose={closeEditModal} size={"lg"}>
            <FormError>
                {errorMessage}
            </FormError>
            <MyPlanView  submit={handleEdit}cancel={closeEditModal} plan={selectedPlan} period={selectedQuarter} year = {selectedYear} />
        </Modalpopup>

        {/*<div id='download-content' style={{ padding:'40px', fontSize:'2rem' , display: downloadBlock ? 'block' : 'none' }} >
            <div >
                <MyPlanView plan={selectedDownloadPlan} period={selectedQuarter} year = {selectedYear} view='download' />
            </div>  
        </div>*/}
        <div id="generate-pdf-btn">
            <GeneratePDF plans={selectedDownloadPlan ? [selectedDownloadPlan] : []} period={selectedQuarter} year = {selectedYear} view='download' isDownload= {downloadBlock}  />
        </div> 
       
    </>
}

export default AllPlan;
